module.exports = __webpack_public_path__ + "img/badge_esperienze.bbd1544b.jpg";